import axios from 'axios';
import React from 'react';
import { Link } from 'react-router-dom';
import ExtraSection from './ExtraSection';
import Logger from '../../toolkit/logger/Logger';
import InputPassword from '../widgets/input-password/InputPassword';
import AuthService from '../../services/auth-service';
import auth from '../../utils/auth';
import * as httpService from '../../services/http-service';

import 'particles.js';
import './Login.scss';

const particleConfig = require('./particlesjs-config.json');

class Login extends React.Component {

  authService = new AuthService();

  state = {
    username: '',
    password: '',
    error: '',
  }

  constructor(props: any) {
    super(props);
    if (localStorage.getItem('token')) {
      window.location.href = '/dashboard';
    }
  }

  render() {
    const urlParams = new URLSearchParams(window.location.search);
    const forget = urlParams.get('forget') === 'true';
    return (
      <div className="login-page-component" id="particle-div">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-12 mx-auto login-card-container">
              <div className="login-card">
                <div className="row h-100 w-100 mx-0">
                  <div className="col-lg-6 col-12 h-100">
                    <form className="login-form">
                      <h1 className="login-title">ورود کاربران</h1>
                      <div className="form-group">
                        <input
                          autoFocus
                          type="text"
                          className="form-control gray-input-text login-input"
                          placeholder="نام کاربری"
                          onKeyDown={this.handleKeyDown}
                          onChange={this.handleUsernameChange}
                        />
                      </div>
                      <div className="form-group password-group">
                        <InputPassword
                          placeholder="رمز عبور"
                          onKeyDown={this.handleKeyDown}
                          onChange={this.handlePasswordChange} />
                      </div>
                      {(!forget) ? '' :
                        <div className="form-group text-success text-center" style={{ fontSize: '0.9rem' }}>
                          رمز یکبار مصرف جهت ورود شما به سیستم پیامک شد
                        </div>
                      }
                      {(this.state.error === null) ? '' :
                        <div className="form-group text-danger text-center" style={{ fontSize: '0.9rem' }}>
                          {this.state.error}
                        </div>
                      }
                      <div className="form-group">
                        <button
                          onClick={this.tryLogin}
                          className="btn btn-block btn-success">ورود به سیستم</button>
                      </div>
                      <div className="text-center">
                        <Link to="/forget-password" className="form-note">
                          <b>رمز عبور</b> خود را <b>فراموش</b> کردید؟
                        </Link>
                      </div>
                    </form>
                  </div>
                  <ExtraSection />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    (window as any).particlesJS('particle-div', particleConfig, () => {
      console.log('Particles Load');
    });
  }

  private handleUsernameChange = (e: any) => this.setState({ username: e.target.value });

  private handlePasswordChange = (e: any) => this.setState({ password: e.target.value });

  private handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      this.tryLogin(e);
    }
  }

  private tryLogin = async (e: any) => {
    e.preventDefault();
    const { username, password } = this.state;
    try {
      const response = await this.authService.login(username, password);
      Logger.log('Login::Response =>', response);
      if (response && response.token) {
        Logger.log('Login::SetToken =>', response);
        auth.setJwt(response.token);
        httpService.resetToken();
        Logger.log('Login::LocalStorage =>', localStorage.getItem('token'));
        Logger.log('Login::AxiosDefault =>', axios.defaults.headers.common['x-access-token']);
        this.setState({ error: '' });
        const verify = await auth.verify();
        if (verify.throwawayFlag) {
          window.location.href = '/reset-password';
          return;
        }
        window.location.href = '/dashboard';
        return;
      }
    }
    catch (e) {
      this.setState({ error: 'نام کاربر یا رمز عبور اشتباه است' });
    }
  }

}

export default Login;
